<template>
  <div>
    <div class="mb-4">
      <el-button type="primary" @click="addDialogVisible = true">添加账号</el-button>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%">
      <el-table-column
        prop="userRegtime"
        label="注册日期"
        width="180">
        <template slot-scope="scope">
          <i class="el-icon-time"></i>
          <span style="margin-left: 10px">{{ formatDate(scope.row.userRegtime) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="username"
        label="用户名"
        width="180">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <p>用户名: {{ scope.row.username }}</p>
            <p>手机号: {{ scope.row.userMobile }}</p>
            <p>角色: {{ scope.row.role }}</p>
            <div slot="reference" class="name-wrapper">
              <el-tag size="medium">{{ scope.row.username }}</el-tag>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column 
        prop="carNumber" 
        label="车牌号" 
        width="120">
      </el-table-column>
      <el-table-column 
        prop="status" 
        label="状态" 
        width="120">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
            {{ scope.row.status === 1 ? '启用' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="340"> <!-- 增加宽度以容纳新按钮 -->
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="handleGoToOrder(scope.row)">班产表</el-button>
          <!-- 新增维修表按钮 -->
          <el-button
            size="mini"
            type="warning"
            @click="handleGoToRepair(scope.row)">维修表</el-button>
          <el-button
            size="mini"
            @click="handleEdit(scope.row)">编辑</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    
    <!-- 编辑对话框 -->
    <el-dialog :visible.sync="editDialogVisible" title="编辑用户信息">
      <el-form :model="editForm" label-width="120px" ref="editForm" :rules="editFormRules">
        <el-form-item label="用户ID" prop="userId">
          <el-input v-model="editForm.userId" disabled></el-input>
        </el-form-item>
        <el-form-item label="用户名" prop="username">
          <el-input v-model="editForm.username"></el-input>
        </el-form-item>
        <el-form-item label="车牌号" prop="carNumber">
          <el-input v-model="editForm.carNumber"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="editForm.password"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="userMobile">
          <el-input v-model="editForm.userMobile"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="editForm.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEdit">确定</el-button>
      </div>
    </el-dialog>
    
    <!-- 添加账号对话框 -->
    <el-dialog :visible.sync="addDialogVisible" title="添加账号">
      <el-form :model="addForm" label-width="120px" ref="addForm" :rules="addFormRules">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="addForm.username"></el-input>
        </el-form-item>
        <el-form-item label="车牌号" prop="carNumber">
          <el-input v-model="addForm.carNumber"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="addForm.password"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="userMobile">
          <el-input v-model="addForm.userMobile"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitAdd">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import adminrequest from '@/utils/adminrequest'

export default {
  data() {
    return {
      tableData: [],
      editDialogVisible: false,
      editForm: {
        userId: null,
        username: '',
        carNumber: '',
        password: '',
        userMobile: '',
        status: 1
      },
      editFormRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        userMobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
        ]
      },
      addDialogVisible: false,
      addForm: {
        username: '',
        carNumber: '',
        password: '',
        userMobile: ''
      },
      addFormRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        carNumber: [
          { required: true, message: '请输入车牌号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        userMobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      const options = {method: 'GET', url: '/admin/manage/user/getUserList'};
      
      adminrequest.request(options).then(response => {
        if (response.data.code === 200) {
          this.tableData = response.data.data;
        } else {
          this.$message.error('获取数据失败：' + response.data.message);
        }
      }).catch(error => {
        console.error(error);
        this.$message.error('网络请求错误：' + error.message);
      });
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      return date.toLocaleDateString();
    },
    handleEdit(row) {
      // 复制选中行的数据到编辑表单
      this.editForm = { ...row };
      this.editDialogVisible = true;
    },
    // 跳转到订单管理页面的方法
    handleGoToOrder(row) {
      // 使用vue-router的push方法跳转，并携带userId参数
      this.$router.push({
        path: '/ManageOrder',
        query: {
          userId: row.userId  // 将userId作为查询参数传递
        }
      });
    },
    // 新增：跳转到维修表页面的方法
    handleGoToRepair(row) {
      // 使用vue-router的push方法跳转，并携带userId参数
      this.$router.push({
        path: '/ManageRepair',
        query: {
          userId: row.userId  // 将userId作为查询参数传递
        }
      });
    },
    handleDelete(row) {
      this.$confirm('确定要删除该用户吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const options = {
          method: 'DELETE',
          url: '/admin/manage/user/deleteUser',
          params: {userId: row.userId}
        };
        
        adminrequest.request(options).then(response => {
          if (response.data.code === 200) {
            this.$message({
              type: 'success',
              message: '删除成功'
            });
            this.fetchData(); // 重新加载数据
          } else {
            this.$message.error('删除失败：' + response.data.message);
          }
        }).catch(error => {
          console.error(error);
          this.$message.error('网络请求错误：' + error.message);
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
    },
    submitEdit() {
      // 验证表单
      this.$refs.editForm.validate(valid => {
        if (valid) {
          const options = {
            method: 'POST',
            url: '/admin/manage/user/updateUser',
            headers: {'content-type': 'application/json'},
            data: this.editForm
          };
          
          adminrequest.request(options).then(response => {
            if (response.data.code === 200) {
              this.$message({
                type: 'success',
                message: '更新成功'
              });
              this.editDialogVisible = false;
              this.fetchData(); // 重新加载数据
            } else {
              this.$message.error('更新失败：' + response.data.message);
            }
          }).catch(error => {
            console.error(error);
            this.$message.error('网络请求错误：' + error.message);
          });
        } else {
          this.$message.error('表单验证失败，请检查输入');
          return false;
        }
      });
    },
    submitAdd() {
      // 验证表单
      this.$refs.addForm.validate(valid => {
        if (valid) {
          // 默认设置状态为启用(1)
          const formData = { ...this.addForm, status: 1 };
          
          const options = {
            method: 'POST',
            url: '/admin/manage/user/addUser',
            headers: {'content-type': 'application/json'},
            data: formData
          };
          
          adminrequest.request(options).then(response => {
            if (response.data.code === 200) {
              this.$message({
                type: 'success',
                message: '添加成功'
              });
              this.addDialogVisible = false;
              this.addForm = {
                username: '',
                carNumber: '',
                password: '',
                userMobile: ''
              };
              this.fetchData(); // 重新加载数据
            } else {
              this.$message.error('添加失败：' + response.data.message);
            }
          }).catch(error => {
            console.error(error);
            this.$message.error('网络请求错误：' + error.message);
          });
        } else {
          this.$message.error('表单验证失败，请检查输入');
          return false;
        }
      });
    }
  }
}
</script>
